import type React from 'react';
import { CardHeader, Divider, CardContent, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';

import type { RequestProps, BulkRequestProps } from '../../models';

const style = {
	divider: { borderBottomWidth: 1.5 },
};

interface SingleRequestAddressInfoProps {
	candidate: RequestProps['candidate'];
}

interface BulkRequestAddressInfoProps {
	location: BulkRequestProps['location'];
}

export const AddressInfo = {
	SingleRequest: ({ candidate }: SingleRequestAddressInfoProps) => (
		<>
			<CardHeader title="Address" />
			<Divider sx={style.divider} />
			<CardContent>
				<Grid container spacing={2}>
					<Grid size={{ xs: 6 }}>
						<Typography variant="subtitle1" gutterBottom>
							Postcode
						</Typography>
						<Typography variant="body1" gutterBottom>
							{candidate?.addrPostcode}
						</Typography>
					</Grid>
					<Grid size={{ xs: 6 }}>
						<Typography variant="subtitle1" gutterBottom>
							State
						</Typography>
						<Typography variant="body1" gutterBottom>
							{candidate?.addrState}
						</Typography>
					</Grid>
				</Grid>
			</CardContent>
		</>
	),
	BulkRequest: ({ location }: BulkRequestAddressInfoProps) => (
		<>
			<CardHeader title="Address" />
			<Divider sx={style.divider} />
			<CardContent>
				<Grid container spacing={2}>
					<Grid size={{ xs: 8 }}>
						<Typography variant="body1" gutterBottom>
							{location}
						</Typography>
					</Grid>
				</Grid>
			</CardContent>
		</>
	),
};
